import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import serviceRequestService from '../api/serviceRequestService';
import searchService from '../api/searchService';
import { useNotifications } from '../context/NotificationContext';
import Field from '../components/common/Field';

const EMPTY = {
  clientName: '', clientPhone: '', clientEmail: '', city: '',
  categoryId: '', technicianId: '', description: '',
};

export default function ServiceRequestPage() {
  const { t } = useTranslation();
  const notify = useNotifications();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [types, setTypes] = useState([]);
  const [technicians, setTechnicians] = useState([]);
  const idea = params.get('idea');
  const intent = params.get('intent');
  const prefill = idea !== null
    ? (idea ? t('landing.prefill.idea', { idea }) : t('landing.prefill.ideaFree'))
    : (intent && ['partner', 'investor', 'workforce', 'academy'].includes(intent) ? t(`landing.prefill.${intent}`) : '');
  const [form, setForm] = useState({ ...EMPTY, technicianId: params.get('technicianId') || '', description: prefill });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  useEffect(() => {
    searchService.technicianTypes().then(setTypes).catch(() => {});
    searchService.listTechnicians({ size: 100 })
      .then((p) => setTechnicians(p.content || []))
      .catch(() => {});
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await serviceRequestService.create({
        ...form,
        categoryId: form.categoryId || null,
        technicianId: form.technicianId || null,
        clientEmail: form.clientEmail || null,
      });
      notify.success(t('serviceRequest.sent'));
      navigate('/');
    } catch (err) {
      notify.apiError(err);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="page">
      <div className="container auth-wrap wide">
        <div className="card pad">
          <h2 style={{ marginBottom: '.25rem' }}>{t('serviceRequest.title')}</h2>
          <p className="muted" style={{ marginBottom: '1.25rem' }}>{t('serviceRequest.subtitle')}</p>
          <form onSubmit={submit}>
            <div className="form-grid">
              <Field label={t('serviceRequest.yourName')} required value={form.clientName} onChange={set('clientName')} />
              <Field label={t('serviceRequest.yourPhone')} required value={form.clientPhone} onChange={set('clientPhone')} placeholder="+243…" />
              <Field label={t('serviceRequest.yourEmail')} type="email" value={form.clientEmail} onChange={set('clientEmail')} />
              <Field label={t('serviceRequest.city')} required value={form.city} onChange={set('city')} placeholder="Kinshasa" />
              <Field as="select" label={t('serviceRequest.category')} value={form.categoryId} onChange={set('categoryId')}>
                <option value="">{t('common.none')}</option>
                {types.map((x) => <option key={x.id} value={x.id}>{x.name}</option>)}
              </Field>
              <Field as="select" label={t('serviceRequest.chooseTechnician')} value={form.technicianId} onChange={set('technicianId')}>
                <option value="">{t('common.none')}</option>
                {technicians.map((x) => (
                  <option key={x.id} value={x.id}>{x.firstName} {x.lastName} — {x.technicianTypeName}</option>
                ))}
              </Field>
            </div>
            <Field as="textarea" label={t('serviceRequest.description')} required value={form.description} onChange={set('description')} maxLength={2000} />
            <button className="btn accent block" disabled={busy}>
              {busy ? t('common.loading') : t('serviceRequest.send')}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
